import { lazy, type ComponentType } from 'react'
import type { StepType } from '@esign/contracts'
import { InfoStep } from './steps/InfoStep.js'
import { LinkAccountStep } from './steps/LinkAccountStep.js'
import { ReviewStep } from './steps/ReviewStep.js'
import { SignStep } from './steps/SignStep.js'
import type { StepProps } from './types.js'

/**
 * Registry — thêm một loại bước mới là thêm MỘT dòng ở đây.
 *
 * Đây là chỗ thay thế cho `if (step === 3) return "contract"`. Orchestrator tra bảng
 * bằng `step.type` rồi vẽ; nó không biết có bao nhiêu loại bước và không cần biết.
 * Partner khác nhau = mảng `steps` khác nhau trong config, không phải nhánh code khác nhau.
 */

/**
 * eKYC tải riêng: SDK nhà cung cấp thật đều nặng, và phần lớn partner không có bước này.
 * Không có lý do bắt người ký hợp đồng 3 bước tải về code của bước thứ tư.
 */
const EkycStep = lazy(() => import('./steps/EkycStep.js'))

/**
 * Ép kiểu ở đây là có kiểm soát: mỗi component tự khai `StepProps<'info'>`, `StepProps<'ekyc'>`…
 * nên bên trong nó `step.config` có kiểu thật. Bảng này xoá phần thu hẹp đó đi, và điều
 * giữ cho nó đúng là orchestrator luôn tra bằng chính `step.type` của `step` mà nó truyền vào.
 */
type AnyStepComponent = ComponentType<StepProps>

export const STEP_REGISTRY: Record<StepType, AnyStepComponent> = {
  info: InfoStep as AnyStepComponent,
  link_account: LinkAccountStep as AnyStepComponent,
  ekyc: EkycStep as AnyStepComponent,
  review: ReviewStep as AnyStepComponent,
  sign: SignStep as AnyStepComponent,
}
